import { AlertCircle } from "lucide-react";

export function getStockBadge(quantity) {
  if (quantity === 0) {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 text-xs font-medium rounded-full">
        <AlertCircle size={12} />
        Out of Stock
      </span>
    );
  } else if (quantity <= 10) {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 text-orange-600 dark:text-orange-400 text-xs font-medium rounded-full">
        <AlertCircle size={12} />
        Low Stock
      </span>
    );
  }
  return null;
}
export function formatPrice(amount) {
  return new Intl.NumberFormat("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
